import { retailerContactUsValidFields } from './schema';

export const isRetailerContactUsField = (
  field: unknown,
): field is (typeof retailerContactUsValidFields)[number] => {
  return (
    typeof field === 'string' &&
    retailerContactUsValidFields?.includes(
      field as (typeof retailerContactUsValidFields)[number],
    )
  );
};

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  window.parentIFrame?.scrollToOffset(0, 0);
}
